import React from 'react';

interface DeliveredCloudProps {
  size?: number;
  iconColor?: string;
  backgroundColor?: string;
  strokeWidth?: number;
}

export const DeliveredCloud = ({ 
  size = 40, 
  iconColor = 'white',
  backgroundColor = '#12876A',
  strokeWidth = 1.33333 
}: DeliveredCloudProps) => {
  
  return (
    <div 
      style={{ 
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <svg width={size * 0.6} height={size * 0.6} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M13.3359 11.1619C14.1503 10.4894 14.6693 9.47196 14.6693 8.33333C14.6693 6.30829 13.0276 4.66667 11.0026 4.66667C10.8569 4.66667 10.7206 4.59066 10.6467 4.46516C9.77731 2.98989 8.17222 2 6.33594 2C3.57451 2 1.33594 4.23858 1.33594 7C1.33594 8.3774 1.8929 9.62472 2.7939 10.529" 
          stroke={iconColor} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M11.3359 10L6.70833 14.2083L5 12.5" 
          stroke={iconColor} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

